function domain(name) {
  const scale = this.__execs__.scale; //TODO: yLine, yBar 처리
  
  if (name in scale && scale.hasOwnProperty(name)) {
    return scale[name].domain();
  } else {
    return null;
  }
}

export default domain;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/domain.js